import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ScriptMetaEditor } from "@/components/case/script-meta-editor";
import { Skeleton } from "@/components/ui/skeleton";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function VersionMetaPanel({
  caseId,
  versionId,
}: {
  caseId: string;
  versionId: string;
}) {
  const auth = useAuth();
  const detailQuery = useQuery({
    queryKey: ["case", caseId],
    queryFn: () => api.getCase(caseId),
    enabled: auth.status === "authed",
  });

  if (auth.status === "loading" || detailQuery.isLoading) {
    return <Skeleton className="h-64 w-full" />;
  }
  if (auth.status === "anon" || !detailQuery.data) return null;

  const version = detailQuery.data.versions.find((v) => v.id === versionId);
  const caseRow = detailQuery.data.case;

  return (
    <ScriptMetaEditor
      caseId={caseId}
      versionId={versionId}
      caseDisplayId={caseRow.id}
      versionStatus={version?.status ?? null}
      hasPipeline={version?.hasPipeline ?? false}
      role="gate"
      title="元信息"
      description="此版本的流水线关卡。确认剧本与元信息后启动。编辑会保存到与案件「源文」相同的字段。"
      autoDraft
      showStartPipeline
      crossLink={
        <>
          日常案件编辑在{" "}
          <Link
            to="/cases/$caseId/source"
            params={{ caseId }}
            className="font-medium text-foreground underline-offset-4 hover:underline"
          >
            案件源文
          </Link>
          。此页用于确认剧本与元信息并启动流水线。
        </>
      }
    />
  );
}
